/**
 * Supporting class for the DatePicker.vue component. Using this ensures change changes
 * get updated via the model. Strings get dereferenced and will stop getting updated.
 */
export class DatePickerObj
{
	/**
	 * DatePickerObject Constructor
	 * See https://flatpickr.js.org/formatting/ for formatting information
	 * @param p_date {string} Date string
	 * @param p_config {
	 * "dateFormat": string,
	 * "altFormat": string,
	 * "enableTime": boolean,
	 * "noCalendar": boolean,
	 * "time_24hr": boolean,
	 * "minuteIncrement": number} dateFormat is db format, altFormat is display format
	 */
	constructor(p_date, p_config)
	{
		this.date = p_date

		this.config = {}
		this.config['dateFormat'] = p_config['dateFormat'] ? p_config.dateFormat : 'Y-m-d'
		this.config['altFormat'] = p_config['altFormat'] ? p_config.altFormat : 'm-d-Y'
		this.config['enableTime'] = p_config['enableTime'] ? p_config.enableTime : false
		this.config['noCalendar'] = p_config['noCalendar'] ? p_config.noCalendar : false
		this.config['time_24hr'] = p_config['time_24hr'] ? p_config.time_24hr : false
		this.config['minuteIncrement'] = p_config['minuteIncrement'] ? p_config.minuteIncrement : 5
	}

	/**
	 * Returns the date
	 * @returns {string} value of date
	 */
	getDate()
	{
		return this.date
	}

	/**
	 * Returns the date
	 * @returns {string} value of date
	 */
	getUTCDate()
	{
		return new Intl.DateTimeFormat('sv-SE', {
			dateStyle: 'short',
			timeStyle: 'medium',
			timeZone: 'UTC' // Forces UTC timezone calculation
		}).format(new Date(this.date))
	}
}